/**
 * Dimension fields whose value is a string, not a number.
 *
 * Plotting.updateDimension coerces every dimension field with Number() unless
 * it is listed here, so a select whose id is missing lands in state as NaN and
 * the control silently renders blank — the value looks like it simply refuses
 * to stick, with no error raised anywhere. Any new select field must be added.
 *
 * Kept in its own module so it can be unit tested: importing Plotting.js pulls
 * in the Footer, which pulls in paper.js, which needs a canvas 2D context that
 * jsdom does not provide.
 */
export const STRING_FIELDS = [
  "tunnelside",
  "heightfrom",
  "orientation",
  "orientationsource",
  "ftracedir",
  "fside1",
  "fside2",
  "dlabel",
  // Not strings, but cleared to "" by Input's stale-exact-value guard; the
  // Number() coercion would turn that "" into 0, which Output's exact() then
  // prefers over the hand-typed orientation — the trace plots from 0/0.
  "dirExact",
  "amtExact",
];

/**
 * Tunnel fields fixed for the whole log. Every trace carries its own copy, and
 * each trace validates its chainages against that copy, so an edit made on
 * the first trace (the only one where they are editable) must reach them all.
 */
export const GEOMETRY_FIELDS = [
  "direction",
  "inclination",
  "height",
  "width",
  "widthspl",
  "hw",
  "radiusofcrown",
  "startrd",
  "endrd",
];

/** True when editing `name` on `traceIndex` must be copied to every trace. */
export const appliesToAllTraces = (name, traceIndex) =>
  traceIndex === 0 && GEOMETRY_FIELDS.includes(name);
